/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custompageid2Inputs */

const en_entity_custompageid2 = /** @type {(inputs: Entity_Custompageid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Page ID`)
};

const de_entity_custompageid2 = /** @type {(inputs: Entity_Custompageid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

/**
* | output |
* | --- |
* | "Custom Page ID" |
*
* @param {Entity_Custompageid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custompageid2 = /** @type {((inputs?: Entity_Custompageid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custompageid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompageid2(inputs)
	return de_entity_custompageid2(inputs)
});
export { entity_custompageid2 as "entity_customPageId" }